module.exports = __webpack_public_path__ + "img/datoscabecera.e5752295.png";